module.exports = __webpack_public_path__ + "static/media/hall-C9-11r90-2026.d83d274d.svg";